
export enum Gateway {
  Stripe = 'stripe',
  PayZen = 'payzen',
}
